import DelegationType from '@/ecm/variables/DelegationType'

export default class Delegation {
    constructor(dto) {
        this.id = 0
        this.description = ''
        this.startDate = ''
        this.endDate = ''
        this.delegateContentTypesRights = true
        this.delegateFlows = false
        this.delegateBaskets = false
        this.delegateUserSearches = false
        this.delegatorUser = null
        this.users = []
        this.type = DelegationType.Manual

        if (dto) {
            this.id = dto.Id
            this.description = dto.Description
            this.startDate = dto.StartDate
            this.endDate = dto.EndDate
            this.type = dto.StartDate ? DelegationType.Scheduled : DelegationType.Manual
            this.delegateContentTypesRights = dto.DelegateContentTypesRights
            this.delegateFlows = dto.DelegateFlows
            this.delegateBaskets = dto.DelegateBaskets
            this.delegateUserSearches = dto.DelegateUserSearches
            this.delegatorUser = { id: dto.DelegatorUserId + '', text: dto.DelegatorUserName }
            this.users = dto.DelegatedUserIds.map(function (id) { return { id: id + '', text: '' } })
        }
    }

    toDto() {
        return {
            Id: this.id,
            Description: this.description,
            StartDate: this.startDate,
            EndDate: this.endDate,
            DelegateContentTypesRights: this.delegateContentTypesRights,
            DelegateFlows: this.delegateFlows,
            DelegateBaskets: this.delegateBaskets,
            DelegateUserSearches: this.delegateUserSearches,
            DelegatorUserId: this.delegatorUser.id,
            DelegatedUserIds: this.users.map(item => parseInt(item.id)),
        }
    }
}
